const SIMPLE_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (value) => typeof value === 'string' && SIMPLE_EMAIL_REGEX.test(value);

export default isValidEmail;
